import { TimeBoxCategory } from '../types/timeBox';
import {
  Zap,
  RotateCcw,
  Heart,
  Coffee,
  type LucideIcon,
} from 'lucide-react';

export const timeBoxCategoryConfig: Record<
  TimeBoxCategory,
  {
    label: string;
    icon: LucideIcon;
    color: string;
    actionBg: string;
  }
> = {
  focus: {
    label: 'Focus',
    icon: Zap,
    color: 'bg-sky-100 text-sky-700',
    actionBg: 'bg-sky-50 border border-sky-100',
  },
  routine: {
    label: 'Routine',
    icon: RotateCcw,
    color: 'bg-slate-200 text-slate-600',
    actionBg: 'bg-slate-100 border border-slate-200',
  },
  life: {
    label: 'Life',
    icon: Heart,
    color: 'bg-green-100 text-green-700',
    actionBg: 'bg-green-50 border border-green-100',
  },
  rest: {
    label: 'Rest',
    icon: Coffee,
    color: 'bg-amber-100 text-amber-700',
    actionBg: 'bg-amber-50 border border-amber-100',
  },
};
